import styled from 'styled-components';

const SMALL_HEIGHT = '16px';
const MEDIUM_HEIGHT = '32px';
const LARGE_HEIGHT = '48px';

const Gap = ({ height, small, large }) => {
  let heightValue = MEDIUM_HEIGHT;

  if (height) {
    heightValue = height;
  } else if (large) {
    heightValue = LARGE_HEIGHT;
  } else if (small) {
    heightValue = SMALL_HEIGHT;
  }

  return <Element height={heightValue} />;
};

const Element = styled.div`
  margin: 0 !important;
  padding-bottom: ${props => props.height};
`;

export default Gap;
